export default __webpack_public_path__ + "static/media/AmericanExpress.6698ce9d.png";